if (typeof ComplementaryProductCart === 'undefined') {
    class ComplementaryProductCart {
        constructor() {
            this.init();
        }

        init() {
            document.addEventListener('click', event => {
                const button = event.target.closest('.complementary-product-add[data-variant-id]');

                if (!button || button.disabled) {
                    return;
                }

                this.addToCart(button);
            });
        }

        async addToCart(button) {
            const variantId = button.dataset.variantId;
            const text = button.querySelector('.complementary-product-add__text');
            const loading = button.querySelector('.complementary-product-add__loading');

            button.disabled = true;

            if (text) {
                text.hidden = true;
            }

            if (loading) {
                loading.hidden = false;
            }

            try {
                const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: Number(variantId),
                                quantity: 1
                            }
                        ]
                    })
                });

                if (!response.ok) {
                    throw new Error('Unable to add product to cart');
                }

                const item = await response.json();

                document.dispatchEvent(new CustomEvent('complementary-product:added', {
                    detail: {
                        item
                    }
                }));

                await this.refreshCart();

                button.classList.add('is-added');

                if (text) {
                    text.hidden = false;
                    text.textContent = 'Added';
                }

                if (loading) {
                    loading.hidden = true;
                }

                setTimeout(() => {
                    button.classList.remove('is-added');

                    if (text) {
                        text.textContent = 'Add to bag';
                    }

                    button.disabled = false;
                }, 1500);
            } catch (error) {
                if (text) {
                    text.hidden = false;
                    text.textContent = 'Add to bag';
                }

                if (loading) {
                    loading.hidden = true;
                }

                button.disabled = false;
            }
        }

        async refreshCart() {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                return;
            }

            const cart = await response.json();

            document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart
                }
            }));
        }
    }

    window.addEventListener('load', () => {
        window.complementaryProductCart = new ComplementaryProductCart();
    });
}
